/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseMediaList,
    PressReleaseMediaListFromJSON,
    PressReleaseMediaListFromJSONTyped,
    PressReleaseMediaListToJSON,
} from './PressReleaseMediaList';

/**
 * GET /media_list/prtimes
 * @export
 * @interface GetPressReleaseMediaListPrtimesResponse
 */
export interface GetPressReleaseMediaListPrtimesResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPressReleaseMediaListPrtimesResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetPressReleaseMediaListPrtimesResponse
     */
    message: string;
    /**
     * 
     * @type {Array<PressReleaseMediaList>}
     * @memberof GetPressReleaseMediaListPrtimesResponse
     */
    data: Array<PressReleaseMediaList>;
}

export function GetPressReleaseMediaListPrtimesResponseFromJSON(json: any): GetPressReleaseMediaListPrtimesResponse {
    return GetPressReleaseMediaListPrtimesResponseFromJSONTyped(json, false);
}

export function GetPressReleaseMediaListPrtimesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressReleaseMediaListPrtimesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(PressReleaseMediaListFromJSON)),
    };
}

export function GetPressReleaseMediaListPrtimesResponseToJSON(value?: GetPressReleaseMediaListPrtimesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(PressReleaseMediaListToJSON)),
    };
}

